// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"bd9ba889","69":"3ecce1cc","128":"6c7b5365","288":"afefec54","295":"5c078815","386":"a4d856c0","490":"1f9df0ea","509":"5b03c43b","578":"4e9701b2","584":"0b32c9b8","590":"1a00acce","592":"84d02cc8","606":"0ab09ac4","773":"a4bd3aed","823":"0d24a2de"}[chunkId] + ".chunk.js";
};